
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'How do upgrades work?',
    howToUseTitle: 'How to upgrade:',
    howToUseStep1: 'Tap «Your item» and pick a skin from your inventory',
    howToUseStep2: 'Tap «Target» and pick the skin you want to get',
    howToUseStep3: 'The dial shows the chance and the multiplier',
    howToUseStepCredits: 'Want a better chance — drag the slider and add coins from your balance to the item',
    howToUseStep4: 'Tap «Upgrade» — no extra confirmation',
    rulesTitle: 'Rules:',
    rulesRule1: 'Any item worth 1000 coins or more can be upgraded, including knives and gloves',
    rulesRule2: 'The chance depends on the price gap between the items',
    rulesRule3: 'The pricier the target, the lower the chance',
    rulesRule4: 'If it fails, both the item and the coins you added are lost',
    rulesRule5: 'If it succeeds, the target lands in your inventory — you can upgrade it again right away',
    rulesCredits1: 'Coins from your balance are added on top of the item price, so the chance grows',
    rulesCredits2: 'An item is always required — coins alone cannot be upgraded',
    rulesCredits3: 'The chance never goes above 60%, so the entry cannot exceed 75% of the target price',
  },
  ru: {
    title: 'Как работает апгрейд?',
    howToUseTitle: 'Как улучшить:',
    howToUseStep1: 'Нажми «Твой предмет» и выбери скин из инвентаря',
    howToUseStep2: 'Нажми «Цель» и выбери скин, который хочешь получить',
    howToUseStep3: 'Циферблат покажет шанс и множитель',
    howToUseStepCredits: 'Хочешь шанс выше — двинь ползунок и добавь к предмету монеты со своего баланса',
    howToUseStep4: 'Нажми «Улучшить» — без лишних подтверждений',
    rulesTitle: 'Правила:',
    rulesRule1: 'Улучшить можно любой предмет стоимостью от 1000 монет, включая ножи и перчатки',
    rulesRule2: 'Шанс зависит от разницы цен предметов',
    rulesRule3: 'Чем дороже цель, тем ниже шанс',
    rulesRule4: 'При неудаче сгорает и предмет, и добавленные монеты',
    rulesRule5: 'При успехе цель попадает в инвентарь — её можно сразу улучшить дальше',
    rulesCredits1: 'Монеты с баланса прибавляются к цене предмета, поэтому шанс растёт',
    rulesCredits2: 'Предмет нужен всегда — на одних монетах улучшить нельзя',
    rulesCredits3: 'Шанс не бывает выше 60%, поэтому вход не может превышать 75% цены цели',
  },
  uz: {
    title: 'Apgreyd qanday ishlaydi?',
    howToUseTitle: 'Qanday yaxshilash:',
    howToUseStep1: '«Buyuming»ni bos va inventardan skin tanla',
    howToUseStep2: '«Maqsad»ni bos va olmoqchi boʻlgan skinni tanla',
    howToUseStep3: 'Siferblat imkoniyat va koeffitsientni koʻrsatadi',
    howToUseStepCredits: 'Imkoniyat yuqoriroq boʻlsin desang — slayderni sur va buyumga balansdan tanga qoʻsh',
    howToUseStep4: '«Yaxshilash»ni bos — ortiqcha tasdiqlashsiz',
    rulesTitle: 'Qoidalar:',
    rulesRule1: '1000 tangadan qimmat istalgan buyumni yaxshilash mumkin, jumladan pichoq va qoʻlqoplar',
    rulesRule2: 'Imkoniyat buyumlar narxlari farqiga bogʻliq',
    rulesRule3: 'Maqsad qanchalik qimmat boʻlsa, imkoniyat shunchalik past',
    rulesRule4: 'Omad kelmasa, buyum ham, qoʻshilgan tangalar ham yoʻqoladi',
    rulesRule5: 'Omad kelsa, maqsad inventarga tushadi — uni darhol yana yaxshilasa boʻladi',
    rulesCredits1: 'Balansdagi tangalar buyum narxiga qoʻshiladi, shuning uchun imkoniyat oshadi',
    rulesCredits2: 'Buyum har doim kerak — faqat tangalar bilan yaxshilab boʻlmaydi',
    rulesCredits3: 'Imkoniyat 60% dan oshmaydi, shuning uchun kirish maqsad narxining 75% dan koʻp boʻlolmaydi',
  },
  fa: {
    title: 'ارتقا چطور کار می‌کند؟',
    howToUseTitle: 'چطور ارتقا بدهیم:',
    howToUseStep1: 'روی «آیتم تو» بزن و یک اسکین از انبارت انتخاب کن',
    howToUseStep2: 'روی «هدف» بزن و اسکینی را که می‌خواهی انتخاب کن',
    howToUseStep3: 'صفحه شانس و ضریب را نشان می‌دهد',
    howToUseStepCredits: 'شانس بیشتر می‌خواهی — اسلایدر را بکش و از موجودی‌ات به آیتم سکه اضافه کن',
    howToUseStep4: 'روی «ارتقا» بزن — بدون تأیید اضافه',
    rulesTitle: 'قوانین:',
    rulesRule1: 'هر آیتم 1000 سکه به بالا ارتقا می‌شود، از جمله چاقو و دستکش',
    rulesRule2: 'شانس به اختلاف قیمت دو آیتم بستگی دارد',
    rulesRule3: 'هرچه هدف گران‌تر باشد، شانس کمتر است',
    rulesRule4: 'اگر نشد، هم آیتم و هم سکه‌هایی که اضافه کردی از بین می‌رود',
    rulesRule5: 'اگر شد، هدف به انبارت می‌آید — می‌توانی همان لحظه دوباره ارتقایش بدهی',
    rulesCredits1: 'سکه‌های موجودی به قیمت آیتم اضافه می‌شود، پس شانس بالاتر می‌رود',
    rulesCredits2: 'آیتم همیشه لازم است — فقط با سکه نمی‌شود ارتقا داد',
    rulesCredits3: 'شانس از ۶۰٪ بالاتر نمی‌رود، پس ورودی نمی‌تواند بیش از ۷۵٪ قیمت هدف باشد',
  },
  pt: {
    title: 'Como funciona o upgrade?',
    howToUseTitle: 'Como fazer upgrade:',
    howToUseStep1: 'Toque em «Seu item» e escolha uma skin do inventário',
    howToUseStep2: 'Toque em «Alvo» e escolha a skin que quer ganhar',
    howToUseStep3: 'O mostrador exibe a chance e o multiplicador',
    howToUseStepCredits: 'Quer mais chance — arraste o controle e adicione moedas do seu saldo ao item',
    howToUseStep4: 'Toque em «Upgrade» — sem confirmações extras',
    rulesTitle: 'Regras:',
    rulesRule1: 'Qualquer item a partir de 1000 moedas pode receber upgrade, incluindo facas e luvas',
    rulesRule2: 'A chance depende da diferença de preço entre os itens',
    rulesRule3: 'Quanto mais caro o alvo, menor a chance',
    rulesRule4: 'Se falhar, o item e as moedas adicionadas são perdidos',
    rulesRule5: 'Se der certo, o alvo vai para o inventário — você pode fazer upgrade dele de novo na hora',
    rulesCredits1: 'As moedas do saldo somam ao preço do item, então a chance aumenta',
    rulesCredits2: 'Um item é sempre necessário — só com moedas não dá para fazer upgrade',
    rulesCredits3: 'A chance nunca passa de 60%, então a entrada não pode passar de 75% do preço do alvo',
  },
  tr: {
    title: 'Upgrade nasıl çalışır?',
    howToUseTitle: 'Nasıl upgrade yapılır:',
    howToUseStep1: '«Eşyan» kısmına dokun ve envanterden bir skin seç',
    howToUseStep2: '«Hedef» kısmına dokun ve almak istediğin skini seç',
    howToUseStep3: 'Gösterge şansı ve çarpanı gösterir',
    howToUseStepCredits: 'Daha yüksek şans istiyorsan — kaydırıcıyı çek ve eşyaya bakiyenden coin ekle',
    howToUseStep4: '«Upgrade» tuşuna dokun — ekstra onay yok',
    rulesTitle: 'Kurallar:',
    rulesRule1: 'Bıçak ve eldivenler dahil, 1000 coin ve üzeri değerdeki her eşya upgrade edilebilir',
    rulesRule2: 'Şans, eşyalar arasındaki fiyat farkına bağlıdır',
    rulesRule3: 'Hedef ne kadar pahalıysa şans o kadar düşük',
    rulesRule4: 'Başarısız olursa hem eşya hem eklediğin coinler kaybolur',
    rulesRule5: 'Başarılı olursa hedef envanterine düşer — hemen tekrar upgrade edebilirsin',
    rulesCredits1: 'Bakiyedeki coinler eşya fiyatına eklenir, böylece şans artar',
    rulesCredits2: 'Eşya her zaman gerekli — sadece coinle upgrade yapılmaz',
    rulesCredits3: 'Şans %60’ı geçmez, bu yüzden giriş hedef fiyatının %75’ini aşamaz',
  },
  uk: {
    title: 'Як працює апгрейд?',
    howToUseTitle: 'Як покращити:',
    howToUseStep1: 'Натисни «Твій предмет» і обери скін з інвентаря',
    howToUseStep2: 'Натисни «Ціль» і обери скін, який хочеш отримати',
    howToUseStep3: 'Циферблат покаже шанс і множник',
    howToUseStepCredits: 'Хочеш вищий шанс — посунь повзунок і додай до предмета монети зі свого балансу',
    howToUseStep4: 'Натисни «Покращити» — без зайвих підтверджень',
    rulesTitle: 'Правила:',
    rulesRule1: 'Покращити можна будь-який предмет вартістю від 1000 монет, включно з ножами й рукавицями',
    rulesRule2: 'Шанс залежить від різниці цін предметів',
    rulesRule3: 'Чим дорожча ціль, тим нижчий шанс',
    rulesRule4: 'У разі невдачі згорає і предмет, і додані монети',
    rulesRule5: 'У разі успіху ціль потрапляє в інвентар — її можна одразу покращувати далі',
    rulesCredits1: 'Монети з балансу додаються до ціни предмета, тому шанс зростає',
    rulesCredits2: 'Предмет потрібен завжди — самими монетами покращити не можна',
    rulesCredits3: 'Шанс не буває вищим за 60%, тому вхід не може перевищувати 75% ціни цілі',
  },
  de: {
    title: 'Wie funktioniert das Upgrade?',
    howToUseTitle: 'So wertest du auf:',
    howToUseStep1: 'Tippe auf „Dein Item“ und wähle einen Skin aus deinem Inventar',
    howToUseStep2: 'Tippe auf „Ziel“ und wähle den Skin, den du haben willst',
    howToUseStep3: 'Das Zifferblatt zeigt Chance und Multiplikator',
    howToUseStepCredits: 'Willst du eine bessere Chance – zieh den Regler und leg Münzen von deinem Guthaben auf das Item drauf',
    howToUseStep4: 'Tippe auf „Upgrade“ – ohne weitere Bestätigung',
    rulesTitle: 'Regeln:',
    rulesRule1: 'Jedes Item im Wert ab 1000 Münzen kann aufgewertet werden, auch Messer und Handschuhe',
    rulesRule2: 'Die Chance hängt vom Preisunterschied der Items ab',
    rulesRule3: 'Je teurer das Ziel, desto niedriger die Chance',
    rulesRule4: 'Bei einem Fehlschlag sind das Item und die hinzugefügten Münzen weg',
    rulesRule5: 'Bei Erfolg landet das Ziel in deinem Inventar – du kannst es sofort weiter aufwerten',
    rulesCredits1: 'Münzen vom Guthaben werden zum Itempreis addiert, deshalb steigt die Chance',
    rulesCredits2: 'Ein Item ist immer nötig – allein mit Münzen geht kein Upgrade',
    rulesCredits3: 'Die Chance liegt nie über 60 %, daher darf der Eintritt höchstens 75 % des Zielpreises betragen',
  },
  es: {
    title: '¿Cómo funciona el upgrade?',
    howToUseTitle: 'Cómo mejorar:',
    howToUseStep1: 'Toca «Tu objeto» y elige un skin de tu inventario',
    howToUseStep2: 'Toca «Objetivo» y elige el skin que quieres conseguir',
    howToUseStep3: 'El dial muestra la probabilidad y el multiplicador',
    howToUseStepCredits: 'Si quieres más probabilidad, mueve el control deslizante y añade al objeto monedas de tu saldo',
    howToUseStep4: 'Toca «Upgrade»: sin confirmaciones de más',
    rulesTitle: 'Reglas:',
    rulesRule1: 'Se puede mejorar cualquier objeto que valga 1000 monedas o más, incluidos cuchillos y guantes',
    rulesRule2: 'La probabilidad depende de la diferencia de precio entre los objetos',
    rulesRule3: 'Cuanto más caro es el objetivo, menor es la probabilidad',
    rulesRule4: 'Si falla, se pierden tanto el objeto como las monedas añadidas',
    rulesRule5: 'Si sale bien, el objetivo llega a tu inventario y puedes mejorarlo de nuevo enseguida',
    rulesCredits1: 'Las monedas del saldo se suman al precio del objeto, por eso sube la probabilidad',
    rulesCredits2: 'Siempre hace falta un objeto: solo con monedas no se puede mejorar',
    rulesCredits3: 'La probabilidad nunca pasa del 60 %, así que la entrada no puede superar el 75 % del precio del objetivo',
  },
  pl: {
    title: 'Jak działa upgrade?',
    howToUseTitle: 'Jak ulepszyć:',
    howToUseStep1: 'Dotknij „Twój przedmiot” i wybierz skina z ekwipunku',
    howToUseStep2: 'Dotknij „Cel” i wybierz skina, którego chcesz zdobyć',
    howToUseStep3: 'Tarcza pokaże szansę i mnożnik',
    howToUseStepCredits: 'Chcesz większą szansę — przesuń suwak i dodaj do przedmiotu monety ze swojego salda',
    howToUseStep4: 'Dotknij „Upgrade” — bez zbędnych potwierdzeń',
    rulesTitle: 'Zasady:',
    rulesRule1: 'Ulepszyć można dowolny przedmiot wart od 1000 monet, także noże i rękawice',
    rulesRule2: 'Szansa zależy od różnicy cen przedmiotów',
    rulesRule3: 'Im droższy cel, tym niższa szansa',
    rulesRule4: 'Przy porażce przepada i przedmiot, i dodane monety',
    rulesRule5: 'Przy sukcesie cel trafia do ekwipunku — można go od razu ulepszać dalej',
    rulesCredits1: 'Monety z salda są dodawane do ceny przedmiotu, dlatego szansa rośnie',
    rulesCredits2: 'Przedmiot jest zawsze potrzebny — samymi monetami ulepszyć się nie da',
    rulesCredits3: 'Szansa nigdy nie przekracza 60%, więc wejście nie może przekroczyć 75% ceny celu',
  },
});
